import { Handle, Position } from "@xyflow/react";
import { NodeType } from "@zapier/canvas-state";
import classNames from "classnames";
import styles from "./Handles.module.css";

const getLeftHandleClassNames = (isVisible: boolean) =>
  classNames(styles.leftHandle, styles.invisibleHandle, {
    [styles.visibleHandle]: isVisible,
  });

const getRightHandleClassNames = (isVisible: boolean) =>
  classNames(styles.rightHandle, styles.invisibleHandle, {
    [styles.visibleHandle]: isVisible,
  });

const getTopHandleClassNames = (isVisible: boolean) =>
  classNames(styles.topHandle, styles.invisibleHandle, {
    [styles.visibleHandle]: isVisible,
  });

const getBottomHandleClassNames = (isVisible: boolean) =>
  classNames(styles.bottomHandle, styles.invisibleHandle, {
    [styles.visibleHandle]: isVisible,
  });

const getZapBottomHandleClassNames = () =>
  classNames(styles.zapBottomHandle, styles.invisibleHandle);

type Props = {
  nodeType: NodeType;
  isVisible?: boolean;
  isStepConnectable?: boolean;
};

export function Handles({ nodeType, isVisible = false }: Props) {
  function TopRightLeftHandles() {
    return (
      <>
        <Handle
          id="top"
          type="source"
          position={Position.Top}
          isConnectable={isVisible}
          className={getTopHandleClassNames(isVisible)}
        />
        <Handle
          id="right"
          type="source"
          position={Position.Right}
          isConnectable={isVisible}
          className={getRightHandleClassNames(isVisible)}
        />
        <Handle
          id="left"
          type="source"
          position={Position.Left}
          isConnectable={isVisible}
          className={getLeftHandleClassNames(isVisible)}
        />
      </>
    );
  }

  if (nodeType === "default") {
    return (
      <>
        <TopRightLeftHandles />
        <Handle
          id="bottom"
          type="source"
          position={Position.Bottom}
          isConnectable={isVisible}
          className={getBottomHandleClassNames(isVisible)}
        />
      </>
    );
  }

  if (nodeType === "zap") {
    return (
      <>
        <TopRightLeftHandles />
        <Handle
          id="zap-node-bottom-handle"
          type="source"
          position={Position.Bottom}
          isConnectable={false}
          className={getZapBottomHandleClassNames()}
        />
      </>
    );
  }

  if (nodeType === "path") {
    return (
      <>
        <Handle
          id="top"
          type="source"
          position={Position.Top}
          isConnectable={isVisible}
          className={classNames(styles.invisibleHandle, {
            [styles.visibleHandle]: isVisible,
          })}
        />
        <Handle
          id="right"
          type="source"
          position={Position.Right}
          isConnectable={isVisible}
          className={classNames(styles.invisibleHandle, {
            [styles.visibleHandle]: isVisible,
          })}
        />
        <Handle
          id="left"
          type="source"
          position={Position.Left}
          isConnectable={isVisible}
          className={classNames(styles.invisibleHandle, {
            [styles.visibleHandle]: isVisible,
          })}
        />
        <Handle
          id="bottom"
          type="source"
          position={Position.Bottom}
          isConnectable={isVisible}
          className={classNames(styles.invisibleHandle, {
            [styles.visibleHandle]: isVisible,
          })}
        />
      </>
    );
  }

  if (nodeType === "zapStep") {
    return (
      <>
        <Handle
          id="right"
          type="source"
          position={Position.Right}
          isConnectable={isVisible}
          className={classNames(styles.invisibleHandle, {
            [styles.visibleHandle]: isVisible,
          })}
        />
        <Handle
          id="left"
          type="source"
          position={Position.Left}
          isConnectable={isVisible}
          className={classNames(styles.invisibleHandle, {
            [styles.visibleHandle]: isVisible,
          })}
        />
        <Handle
          id="zap-step-top-handle"
          type="target"
          position={Position.Top}
          isConnectable={false}
          className={classNames(styles.invisibleHandle, styles.zapStepHandle)}
        />
        <Handle
          id="zap-step-bottom-handle"
          type="source"
          position={Position.Bottom}
          isConnectable={false}
          className={classNames(styles.invisibleHandle, styles.zapStepHandle)}
        />
      </>
    );
  }
}
